import styled from 'styled-components';
import Screen from '../../../../shared/utils/screen';

const AddonModalContainer = styled.div<{ margin?: boolean }>`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: fixed;
  text-align: center;
  width: ${1920 * Screen.widthRatio}px;
  height: ${1080 * Screen.widthRatio}px;
  margin-top: ${(props) => (props.margin ? -64 * Screen.widthRatio : 0)}px;
`;

export default AddonModalContainer;
